import { SelectionValue } from "features/shared/types/select";
import { Roles, User } from "../types/access";

export const initialFields: User = {
    email: "",
    displayName: "",
    password: "",
    role: Roles.USER,
};

export const ROLE_SELECTION_OPTIONS: Array<SelectionValue<Roles>> = [
    {
        display: "User",
        value: Roles.USER,
    },
    {
        display: "Owner",
        value: Roles.OWNER,
    },
    {
        display: "Admin",
        value: Roles.ADMIN,
    },
];
